require("./bootstrap");
require("./main-navigation");
require("./swiper");
require("./backend");

// Helpers
require("./helpers/constants");
require("./helpers/media-query");

// Effects
require("./effects/parallax");
require("./effects/scroll-sideways");
require("./effects/slide");

// Templates
require("./templates/product-category");
require("./templates/master");
require("./templates/old/support");
